import './index.scss'
export default function Index({ datas, onChange, value }: {
    datas: string[],
    onChange?: (value: string) => void,
    value: string

}) {
    return <div className="select">
        {
            datas.map((item: string) => {
                return <div key={item} className={`Item ${item == value ? "active" : ""}`} onClick={() => {
                    onChange && onChange(item)
                }}>
                    {item}
                </div>
            })
        }
    </div>
}